// extracted by mini-css-extract-plugin
module.exports = {"debugWrapper":"debugWrapper__QDesV"};